import { Box, BoxProps } from "@chakra-ui/react";

const Container = ({
  children,
  ...props
}: {
  children: React.ReactNode;
  head?: React.ReactNode;
} & BoxProps) => {
  return (
    <Box
      w="full"
      h="full"
      bg="white"
      rounded="xl"
      p={4}
      border="1px"
      borderColor="gray.200"
      {...props}
    >
      {children}
    </Box>
  );
};

export default Container;
